(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shoe-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('on:variant:change', (event) => {
    const label = event.detail?.form?.querySelector('.js-selected-shoe-size');
    if (label) label.textContent = event.detail.variant?.title || '—';
  });
  } catch(e) { console.error(e); }
})();

})();
